import Price from "../../../../../appData/price"
import { useBlackFriday } from "../../../../../context/blackFridayContext"
import { usePostPurchase } from "../../../../../context/postPurchaseContext"
import useStrings from "../../../../../localization/useStrings"
import styles from "./Payment.module.scss"

const Payment = () => {
  const { state, actions } = usePostPurchase()

  const pricing = state.promoPricing!

  const totalPrice = pricing.yearlyPriceFull.formatted
  const discountedPrice = pricing.yearlyPriceDiscounted.formatted

  const yearlyPerMonthPrice = pricing.discountedMonthlyPrice.formatted

  const strings = useStrings().premiumToUltimate

  return (
    <div className={styles.container}>
      <button
        className={styles.yearlyContainer}
        onClick={() => {
          actions.purchasePromo()
        }}
      >
        <div className={styles.bannerContainer}>
          <label className={styles.yearlyBannerTitle}>
            {strings.megaSaleBanner}
          </label>
        </div>
        <div className={styles.yearlyInfo}>
          <label className={styles.yearlyTitle}>{strings.upgradeTitle}</label>
          <div className={styles.subtitle}>
            <label>
              {strings.yearlySubtitlePrefix}
              <label
                style={{
                  textDecoration: "line-through",
                  textDecorationThickness: 2,
                }}
              >
                {totalPrice}
              </label>
              {" " + discountedPrice}
            </label>
            <label>
              {yearlyPerMonthPrice} {strings.monthlyPriceSuffix}
            </label>
          </div>
        </div>
      </button>
    </div>
  )
}

export default Payment
